import LanguageToggle from '../../../../../../../pages/investor/components/languageToggle';

export default function LanguagePopover() {
	return <LanguageToggle />;
}
